/**
 * The house AI sparkle (design system §5 — "AI rides the brand").
 *
 * Extracted from `VendorBidComparison` so every AI surface uses one glyph.
 * Draws with `stroke="currentColor"`, so it takes the colour of whatever it
 * sits in — which is the whole reason it exists: the ✨ emoji it replaced is
 * rendered by the OS colour-emoji font and **cannot be recoloured by CSS**, so
 * it stayed a washed-out pale yellow on every background we put it on.
 */
export default function Sparkle({
  size = 13,
  /**
   * Solid glyph instead of the outlined one. Use below ~16px: at small sizes a
   * 2px stroke on a 4-point star closes up on itself and reads as a blob, not
   * a sparkle. Defaults to outlined so existing call sites are unchanged.
   */
  filled = false,
}: {
  size?: number;
  filled?: boolean;
}) {
  const common = { width: size, height: size, viewBox: '0 0 24 24', 'aria-hidden': true } as const;

  if (filled) {
    return (
      <svg {...common} fill="currentColor" stroke="none">
        {/* Four-point sparkle with concave sides — the AI glyph, symmetric
            about (12,12) so it optically centres inside a button. */}
        <path d="M12 2c.62 6.2 3.8 9.38 10 10-6.2.62-9.38 3.8-10 10-.62-6.2-3.8-9.38-10-10C8.2 11.38 11.38 8.2 12 2z" />
      </svg>
    );
  }

  return (
    <svg
      {...common}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3l1.6 4.6L18 9l-4.4 1.4L12 15l-1.6-4.6L6 9l4.4-1.4L12 3z" />
    </svg>
  );
}
